module.exports = __webpack_public_path__ + "static/media/ECU.10b59209.svg";